/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_LDolar_76_36 as Componente_LDolar_76_36,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_RDolar_82_36(e) {
  let t = (0, ReactCompiler.c)(10),
    { confeti: n, tono: r } = e,
    i = n === void 0 || n,
    a = r === void 0 ? `text-(--success)` : r,
    o;
  t[0] === i
    ? (o = t[1])
    : ((o = i && <Componente_LDolar_76_36 />), (t[0] = i), (t[1] = o));
  let s = `celebracion h-24 w-24 ${a}`,
    c,
    l,
    u;
  t[2] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((c = (
        <circle
          cx={`36`}
          cy={`36`}
          r={`32`}
          fill={`currentColor`}
          opacity={`0.12`}
        />
      )),
      (l = (
        <circle
          className={`celebracion-anillo`}
          cx={`36`}
          cy={`36`}
          r={`32`}
          fill={`none`}
          stroke={`currentColor`}
          strokeWidth={`4`}
        />
      )),
      (u = (
        <path
          className={`celebracion-check`}
          d={`M22 37 l10 10 l19 -21`}
          fill={`none`}
          stroke={`currentColor`}
          strokeWidth={`5`}
          strokeLinecap={`round`}
          strokeLinejoin={`round`}
        />
      )),
      (t[2] = c),
      (t[3] = l),
      (t[4] = u))
    : ((c = t[2]), (l = t[3]), (u = t[4]));
  let d;
  t[5] === s
    ? (d = t[6])
    : ((d = (
        <svg
          viewBox={`0 0 72 72`}
          className={s}
          aria-hidden={`true`}
          children={[c, l, u]}
        />
      )),
      (t[5] = s),
      (t[6] = d));
  let f;
  return (
    t[7] !== o || t[8] !== d
      ? ((f = <div className={`relative`} children={[o, d]} />),
        (t[7] = o),
        (t[8] = d),
        (t[9] = f))
      : (f = t[9]),
    f
  );
}
